import { init, registerCallback } from "@bedrock-layout/register-resize-callback";
import useStatefulRef from "@bedrock-layout/use-stateful-ref";
import { useRef, useEffect } from "react";
function useResizeObserver(callback, node) {
  var _a;
  const callbackRef = useRef(callback);
  const nodeRef = useStatefulRef();
  useEffect(() => {
    callbackRef.current = callback;
  });
  const currentNode = (_a = nodeRef.current) != null ? _a : node;
  useEffect(() => {
    init();
    return currentNode ? registerCallback(currentNode, callbackRef.current) : void 0;
  }, [currentNode]);
  return nodeRef;
}
export { useResizeObserver as default };
